import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=08118f38&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=js&"
export * from "./Accessibility.vue?vue&type=script&lang=js&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=08118f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08118f38",
  null
  
)

export default component.exports